import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tax-invoice-form',
  templateUrl: './tax-invoice-form.component.html',
  styleUrls: ['./tax-invoice-form.component.css']
})
export class TaxInvoiceFormComponent implements OnInit {
  title="Tax Invoice";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/tax-invoice/tax-invoice-form/tax-invoice-form.component.ts